import moneyIcon from "@/assets/images/money.svg";
import ProductPic from "@/assets/images/upload_logo_product.png";
import BrandPic from "@/assets/images/upload_logo_brand.png";
import DesignPic from "@/assets/images/upload_logo_design.png";
import HumanPic from "@/assets/images/upload_logo_human.png";
import IconPic from "@/assets/images/upload_logo_icon.png";
import ImagePic from "@/assets/images/upload_logo_image.png";
import MarketPic from "@/assets/images/upload_logo_market.png";
import BrandGuideline from "@/assets/images/BrandGuideline@2x.png";
import BrandDesign from "@/assets/images/InAppSpeces.png";
import InAppSpecs from "@/assets/images/BrandDesign.png";

import marketGuideline from "@/assets/images/upload_logo_market_guideline.png";

export const MenuMap = {
    TEAM_MANAGE: "1",
    PERSONAL_MANAGE: "2",
    MY_DOWNLOAD: "3",
    BUDGET: "4",
    CLASSIFY_MANAGE: "5",
    DATA_DASHBOARD: "6",
    AUTHCODE_MANAGE: "7",
    MY_FAVORITE: "8"
};

export const MenuArr = [
    {
        value: MenuMap.TEAM_MANAGE,
        label: "团队资产管理",
        icon: "avatar-group"
    },
    {
        value: MenuMap.PERSONAL_MANAGE,
        label: "个人资产管理",
        icon: "avatar-o"
    },
    {
        value: MenuMap.MY_DOWNLOAD,
        label: "我的下载",
        icon: "download-o"
    },
    {
        value: MenuMap.MY_FAVORITE,
        label: "我的收藏",
        icon: "star-o"
    },
    {
        value: MenuMap.BUDGET,
        label: "预算管理",
        icon: moneyIcon
    },
    {
        value: MenuMap.CLASSIFY_MANAGE,
        label: "分类管理",
        icon: "theme-o",
        hide: true
    },
    {
        value: MenuMap.DATA_DASHBOARD,
        label: "监控看板",
        icon: "barschart-o",
        hide: true
    },
    {
        value: MenuMap.AUTHCODE_MANAGE,
        label: "授权码管理",
        icon: "shield-success",
        hide: true
    }
];

// 团队首页 暂时的
export const TeamResourceTypeTemporary = [
    {
        value: "1",
        label: "图片库",
        total: 0
    },
    {
        value: "15",
        label: "营销规范",
        total: 0
    },
    {
        value: "6",
        label: "品牌营销素材",
        total: 0
    },
    {
        value: "7",
        label: "产品设计",
        total: 0
    },
    {
        value: "12",
        label: "企业文化",
        total: 0
    }
];

// 单个模块
export const TeamResourceType = [
    {
        value: "1",
        label: "图片库",
        total: 0
    },
    {
        value: "5",
        label: "品牌规范",
        total: 0
    },
    {
        value: "15",
        label: "营销规范",
        total: 0
    },
    {
        value: "6",
        label: "品牌营销素材",
        total: 0
    },
    {
        value: "7",
        label: "产品设计",
        total: 0
    },
    {
        value: "12",
        label: "企业文化",
        total: 0
    },
    {
        value: "16",
        label: "图标库",
        total: 0
    }
];

// 个人中心
export const PersonResourceType = [
    {
        value: "1",
        label: "图片库",
        total: 0
    },
    {
        value: "6",
        label: "品牌营销素材",
        total: 0
    },
    {
        value: "7",
        label: "产品设计",
        total: 0
    },
    {
        value: "16",
        label: "图标库",
        total: 0
    }
];

export const DownloadAuth_ApplyStatus_Type = {
    // 0-申请中，1-已通过，2-已过期，3-已驳回
    APPLYING: 0,
    PASSED: 1,
    EXPIRED: 2,
    REJECTED: 3
}

export const Property_PermissionType = {
    Users: 1,
    Department: 2
}   

// 系统资源整合
export const Resource_Type_Identifier = {
    ALL: "-1",
    PX_IMAGE: "1",
    PX_VIDEO: "2",
    PX_AUDIO: "3",
    PX_FONT: "4",
    BRAND_MATERIAL: "5",
    MARKET_MATERIAL: "6",
    PRODUCT_MATERIAL: "7",
    DESIGN_GUIDE: "8",
    ICON: "9",
    HUMAN_RESOURCE: "10",
    OFFICIAL_MATERIAL: "11",
    CORPORATECULTURE_MATERIAL: "12",
    AIGC: "13",
    PPT: "14",
    MARKET_GUIDELINE: "15", // 营销规范
    ICON_REPOSITORY: "16",
    BRAND_MARKET_MATERIAL: "18" // 品牌市场素材
};

export const Resource_Type_Identifier_NAME = {
    [Resource_Type_Identifier.ALL]: "全部",
    [Resource_Type_Identifier.PX_IMAGE]: "图片",
    [Resource_Type_Identifier.PX_VIDEO]: "视频",
    [Resource_Type_Identifier.PX_AUDIO]: "音频",
    [Resource_Type_Identifier.PX_FONT]: "字体",
    [Resource_Type_Identifier.BRAND_MATERIAL]: "品牌规范",
    [Resource_Type_Identifier.MARKET_MATERIAL]: "品牌营销素材",
    [Resource_Type_Identifier.PRODUCT_MATERIAL]: "产品设计资产",
    [Resource_Type_Identifier.DESIGN_GUIDE]: "产品规范",
    [Resource_Type_Identifier.ICON]: "图标",
    [Resource_Type_Identifier.HUMAN_RESOURCE]: "人力资源素材",
    [Resource_Type_Identifier.OFFICIAL_MATERIAL]: "官方规范",
    [Resource_Type_Identifier.CORPORATECULTURE_MATERIAL]: "企业文化设计资产",
    [Resource_Type_Identifier.AIGC]: "AIGC",
    [Resource_Type_Identifier.PPT]: "PPT",
    [Resource_Type_Identifier.MARKET_GUIDELINE]: "营销规范",
    [Resource_Type_Identifier.ICON_REPOSITORY]: "图标库"
};

export const Resource_Type_Name = {
    "-1": "HOME",
    "1": "PX_IMAGE",
    "2": "PX_VIDEO",
    "3": "PX_AUDIO",
    "4": "PX_FONT",
    "5": "BRAND_MATERIAL",
    "6": "MARKET_MATERIAL",
    "7": "PRODUCT_MATERIAL",
    "8": "DESIGN_GUIDE",
    "9": "ICON",
    "10": "HUMAN_RESOURCE",
    "11": "OFFICIAL_MATERIAL",
    "12": "CORPORATECULTURE_MATERIAL",
    "13": "AIGC",
    "15": "MARKET_GUIDELINE",
    "16": "ICON_REPOSITORY"
};

const picUrl =
    "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E5%B0%8F%E6%80%AA%E7%89%A9%E5%A4%B4%E5%83%8F-1.png";
export const TeamUploadFileList = [
    {
        picUrl: ImagePic,
        label: "图片",
        value: Resource_Type_Identifier.PX_IMAGE,
        describtion: "摄影图、菜品图、AIGC图等图片素材"
    },
    {
        picUrl: BrandPic,
        label: "品牌规范",
        value: Resource_Type_Identifier.BRAND_MATERIAL,
        describtion: "美团标识、美团吉祥物、美团体等素材"
    },
    {
        picUrl: MarketPic,
        label: "品牌营销素材",
        value: Resource_Type_Identifier.MARKET_MATERIAL,
        describtion: "品牌营销场景的组件、海报及人物IP等素材"
    },
    {
        picUrl: ProductPic,
        label: "产品设计资产",
        value: Resource_Type_Identifier.PRODUCT_MATERIAL,
        describtion: "产品设计的页面、模版、组件等素材"
    },
    {
        picUrl: IconPic,
        label: "图标",
        value: Resource_Type_Identifier.ICON,
        describtion: "各类线性、面型产品设计图标"
    },
    // {
    //     picUrl: DesignPic,
    //     label: '设计指南',
    //     value: Resource_Type_Identifier.DESIGN_GUIDE,
    //     describtion: '关于设计资产使用的指导性材料'
    // },
    {
        picUrl: HumanPic,
        label: "企业文化设计资产",
        value: Resource_Type_Identifier.CORPORATECULTURE_MATERIAL,
        describtion: "领导力原则、新闻头图及PPT模版等素材",
        children: [
            {
                value: "1",
                label: "人力资源"
            },
            {
                value: "2",
                label: "新闻照片/视频"
            },
            {
                value: "3",
                label: "PPT模版"
            }
        ]
    },
    {
        picUrl: marketGuideline,
        label: "营销规范",
        value: Resource_Type_Identifier.MARKET_GUIDELINE,
        describtion: "关于营销活动设计规范使用的指导性材料"
    }
];
export const PersonUploadFileList = [
    {
        picUrl: ImagePic,
        label: "图片",
        value: Resource_Type_Identifier.PX_IMAGE,
        describtion: "摄影图、菜品图、AIGC图等图片素材"
    },
    {
        picUrl: MarketPic,
        label: "品牌营销素材",
        value: Resource_Type_Identifier.MARKET_MATERIAL,
        describtion: "品牌营销场景的组件、海报及人物IP等素材"
    },
    {
        picUrl: ProductPic,
        label: "产品设计资产",
        value: Resource_Type_Identifier.PRODUCT_MATERIAL,
        describtion: "产品设计的页面、模版、组件等素材"
    },
    {
        picUrl: IconPic,
        label: "图标",
        value: Resource_Type_Identifier.ICON,
        describtion: "各类线性、面型产品设计图标"
    }
];

export const ImageTypeList = [
    { value: "-1", label: "全部资源类型" },
    { value: "1", label: "图片" },
    { value: "2", label: "插画" },
    { value: "5", label: "矢量图" },
    { value: "3", label: "漫画" },
    { value: "4", label: "图表" }
];
// 团队头像
export const teamAvatarUrlList = [
    // {
    //     name: '',
    //     url: 'https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E5%B0%8F%E6%80%AA%E7%89%A9%E5%A4%B4%E5%83%8F-1-3x.png'
    // },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E5%B0%8F%E6%80%AA%E7%89%A9%E5%A4%B4%E5%83%8F-1.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E5%B0%8F%E6%80%AA%E7%89%A9%E5%A4%B4%E5%83%8F-2-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E5%B0%8F%E6%80%AA%E7%89%A9%E5%A4%B4%E5%83%8F-3-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E5%B0%8F%E6%80%AA%E7%89%A9%E5%A4%B4%E5%83%8F-4-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E5%B0%8F%E6%80%AA%E7%89%A9%E5%A4%B4%E5%83%8F-5-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E5%B0%8F%E6%80%AA%E7%89%A9%E5%A4%B4%E5%83%8F-6-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%89%81%E5%B9%B3%E5%8A%A8%E7%89%A9-1-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%89%81%E5%B9%B3%E5%8A%A8%E7%89%A9-2-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%89%81%E5%B9%B3%E5%8A%A8%E7%89%A9-3-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%89%81%E5%B9%B3%E5%8A%A8%E7%89%A9-4-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%89%81%E5%B9%B3%E5%8A%A8%E7%89%A9-5-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%89%81%E5%B9%B3%E5%8A%A8%E7%89%A9-6-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%8A%BD%E8%B1%A1%E5%A4%B4%E5%83%8F-1-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%8A%BD%E8%B1%A1%E5%A4%B4%E5%83%8F-2-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%8A%BD%E8%B1%A1%E5%A4%B4%E5%83%8F-3-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%8A%BD%E8%B1%A1%E5%A4%B4%E5%83%8F-4-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%8A%BD%E8%B1%A1%E5%A4%B4%E5%83%8F-5-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%8A%BD%E8%B1%A1%E5%A4%B4%E5%83%8F-6-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%B0%B4%E6%9E%9C%E5%A4%B4%E5%83%8F-1-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%B0%B4%E6%9E%9C%E5%A4%B4%E5%83%8F-2-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%B0%B4%E6%9E%9C%E5%A4%B4%E5%83%8F-3-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%B0%B4%E6%9E%9C%E5%A4%B4%E5%83%8F-4-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%B0%B4%E6%9E%9C%E5%A4%B4%E5%83%8F-5-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E6%B0%B4%E6%9E%9C%E5%A4%B4%E5%83%8F-6-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E9%A3%8E%E6%99%AF%E5%A4%B4%E5%83%8F-1-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E9%A3%8E%E6%99%AF%E5%A4%B4%E5%83%8F-2-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E9%A3%8E%E6%99%AF%E5%A4%B4%E5%83%8F-3-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E9%A3%8E%E6%99%AF%E5%A4%B4%E5%83%8F-4-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E9%A3%8E%E6%99%AF%E5%A4%B4%E5%83%8F-5-3x.png"
    },
    {
        name: "",
        url:
            "https://s3plus.sankuai.com/v1/mss_b2add7e7651e40b8936fed8aabe7cf08/pixel-images-v1/team-avatar/%E5%A4%B4%E5%83%8F%E5%88%87%E5%9B%BE/%E9%A3%8E%E6%99%AF%E5%A4%B4%E5%83%8F-6-3x.png"
    }
];

export const CodeComponentLibrary =
    "https://component.sankuai.com/astro/entry/componentlib";

// type of asset 资产类型
export const assetTypeList = [
    {
        picUrl: BrandGuideline,
        label: "Brand Guidelines",
        value: Resource_Type_Identifier.BRAND_MATERIAL,
        describe: "Our brand introduction, visual identity and verbal identity"
    },
    {
        picUrl: InAppSpecs,
        label: "Marketing Resources",
        value: Resource_Type_Identifier.MARKET_GUIDELINE,
        describe: "Brand and marketing design templates for mobile interfaces"
    },
    {
        picUrl: BrandDesign,
        label: "Brand Designs",
        value: Resource_Type_Identifier.BRAND_MARKET_MATERIAL,
        describe: "Corporate culture, offline designs, social media, TVC, etc."
    }
];
